export const SET_NEWS_READ_TIMESTAMP = 'SET_NEWS_READ_TIMESTAMP'

export function setNewsReadTimestamp(timestamp) {
  return {
    type: SET_NEWS_READ_TIMESTAMP,
    timestamp
  }
}



// WEBPACK FOOTER //
// ./src/actions/newsStatus.js